// imports
import Config from '$root/Config';
import Model from '$dependencies/Model';

// private static properties
const FIELDS = {
	allowed: { type: Boolean, default: false },
	// set after a successful fetch so callers can reuse the result for the session
	checked: { type: Boolean, default: false },
};

// class definition
export default class AccessCheckModel extends Model {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.fields = FIELDS;

		// call super constructor
		super(args);

        this.type = args.type;
		this._fetchPromise = null;
	}

	// methods
	fetch(tokens = {}) {
        if(!this.type) {
            console.error('type parameter is required to fetch correct url.');
			return Promise.reject(new Error('AccessCheckModel type is required'));
        }

		const hasTokens = tokens && Object.keys(tokens).length > 0;

		// tokenless checks are session-scoped; reuse after the first success
		if (!hasTokens && this.checked) {
			return Promise.resolve();
		}

		if (!hasTokens && this._fetchPromise) {
			return this._fetchPromise;
		}

		this.setConfig('url', replaceTokens(Config.getUrl(this.type), tokens));

		const request = super.fetch()
			.then((result) => {
				if (!hasTokens) {
					this.checked = true;
				}
				return result;
			})
			.finally(() => {
				if (!hasTokens) {
					this._fetchPromise = null;
				}
			});

		if (!hasTokens) {
			this._fetchPromise = request;
		}

		return request;
	}

	clear(hard = false) {
		this._fetchPromise = null;
		return super.clear(hard);
	}

	parse(data) {
		return super.parse(data);
	}

	destroy() {}

	// utility methods

	// getters & setters
}


function replaceTokens(str, obj) {
    // Regular expression to match tokens like ${token}
    const tokenRegex = /\${(.*?)}/g;

    // Replace tokens in the string with corresponding values from the object
    return str.replace(tokenRegex, (match, token) => {
        // If the token exists in the object, replace it with its value, otherwise keep it as is
        return obj[token] !== undefined ? obj[token] : match;
    });
}
